<style lang="stylus" scope>
    .content_right
        width 100%
        border 1px solid #e0e0e0
        background transparent
        border-radius 4px
        max-width 241px
        margin-right 10px
        margin-top 10px
        margin-bottom 10px

        .content
            border-radius 4px
            // box-shadow 0 1px 6px rgba(0, 0, 0, 0.2)
            background #FFF

            .right_menu
                width auto
                height 38px
                display flex
                border-top-left-radius 4px
                border-top-right-radius 4px
                border-bottom 1px solid #e0e0e0
                background-color #fff
                color #515a6e
                flex-flow row nowrap
                .catalog
                    width 100%
                    height 22px
                    margin 9px 9px 0 9px

            .box-title
                width 100%
                height 49px
                line-height 49px
                user-select none
                background #FFF

                .title-name
                    width 160px
                    white-space nowrap
                    overflow hidden
                    text-overflow ellipsis
                    margin-left 11px

                svg
                    float right
                    display inline-block
                    width 22px
                    height 22px
                    fill currentColor
                    transition all 0.15s
                    margin-right 10px
                    margin-top 12px

                    &:hover
                        color #de5145
            .close-btn
                svg
                    cursor pointer
                    width 12px
                    height 12px
                    margin-top 17px

            .cal_box
                width auto
                border-top 1px solid #e0e0e0
                border-bottom-left-radius 4px
                border-bottom-right-radius 4px
                padding 4px 4px 2% 4px
                overflow-x hidden
                overflow-y auto
                background #FFF

            .ivu-tooltip
                width 100%

            .every-box
                position relative
                width 100%
                height 110px
                border 1px solid #d7d7d7
                margin-bottom 6px
                line-height 107px
                text-align center
                user-select none

                img
                    max-width 96%
                    max-height 106px
                    vertical-align middle

                &:hover
                    background #d7d7d7

                    .formulaTool_box
                        display block

                .formulaTool_box
                    display none
                    position absolute
                    right 10px
                    bottom 10px
                    width 40px
                    height 30px
                    font-size 20px

                    >div
                        position relative
                        float left
                        height 17px
                        width 17px
                        line-height 40px
                        margin-top 8px

                    .updateBtn
                        height 17px
                        width 17px
                        margin-left 10px

                    .deleteBtn
                        height 17px
                        width 17px

            .catalog-name
                display flex
                width 70px
                height 20px
                justify-content space-between
                user-select none

            .ivu-select-dropdown
                width 130px
                .ivu-dropdown-item
                    color black

            .ivu-icon.ivu-icon-ios-arrow-down
                margin-top 2px

    #pop-menu
        width 112px
        height 92px
        padding 0
        position absolute
        background #FFF
        line-height 30px
        border-radius 3px
        font-size 14px
        user-select none
        box-shadow 0 1px 6px rgba(0, 0, 0, 0.2)
        border 1px solid #c1c0c0

        .every-menu
            width 110px
            height 30px
            padding-left 21px
            margin 0
            font-size 12px
            vertical-align middle

            &:hover
                background #c1c0c0
</style>

<template>
    <div class="content_right">
        <div class="content">
            <div class="right_menu">
                <Dropdown trigger="click" class="catalog" placement="bottom-start" @on-click="getCatalog">
                    <span class="catalog-name">
                        常用公式
                        <Icon type="ios-arrow-down"></Icon>
                    </span>

                    <DropdownMenu slot="list">
                        <Dropdown placement="right-start">
                            <DropdownItem>
                                小学
                                <Icon type="ios-arrow-forward"></Icon>
                            </DropdownItem>
                            <DropdownMenu slot="list">
                                <DropdownItem v-for="(item, index) in pris" :name="item" :key="index">{{ item }}</DropdownItem>
                            </DropdownMenu>
                        </Dropdown>

                        <Dropdown placement="right-start">
                            <DropdownItem>
                                初中
                                <Icon type="ios-arrow-forward"></Icon>
                            </DropdownItem>
                            <DropdownMenu slot="list">
                                <DropdownItem v-for="(item, index) in mids" :name="item" :key="index">{{ item }}</DropdownItem>
                            </DropdownMenu>
                        </Dropdown>

                        <Dropdown placement="right-start">
                            <DropdownItem>
                                高中
                                <Icon type="ios-arrow-forward"></Icon>
                            </DropdownItem>
                            <DropdownMenu slot="list">
                                <DropdownItem v-for="(item, index) in higs" :name="item" :key="index">{{ item }}</DropdownItem>
                            </DropdownMenu>
                        </Dropdown>

                        <Dropdown placement="right-start">
                            <DropdownItem>
                                大学
                                <Icon type="ios-arrow-forward"></Icon>
                            </DropdownItem>
                            <DropdownMenu slot="list">
                                <DropdownItem v-for="(item, index) in unis" :name="item" :key="index">{{ item }}</DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </DropdownMenu>
                </Dropdown>
                <Dropdown trigger="click" class="catalog" placement="bottom-start" @on-click="getMineFormula" v-if="!nolimit">
                    <span class="catalog-name" @click="open">
                        我的公式
                        <Icon type="ios-arrow-down"></Icon>
                    </span>
                    <DropdownMenu slot="list">
                        <DropdownItem v-for="item in typeList" :key="item.id" :name="item.name">{{ item.name }}</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </div>
            <div class="box-title close-btn" v-show="isBox && !isMineFormula" @contextmenu.prevent="popMenu($event)">
                <span class="title-name">{{ parentName }} > {{ titleName }}</span>
                <iconSymbol name="math-Del" @click.native="closeBox"></iconSymbol>
            </div>
            <div class="box-title" v-show="isBox && isMineFormula" @contextmenu.prevent="popMenu($event)">
                <span class="title-name">我的公式 > {{ titleName }}</span>
                <Dropdown trigger="click" class="catalog" placement="bottom" @on-click="selectTypeAction" style="float: right">
                    <!-- <Icon type="md-more" style="font-size: 25px;" /> -->
                    <iconSymbol name="math-md-more"></iconSymbol>

                    <!-- <Icon type="ios-refresh-circle-outline" /> -->
                    <DropdownMenu slot="list">
                        <DropdownItem name="rename">改名</DropdownItem>
                        <!-- <DropdownItem name="addFormula">新增公式</DropdownItem> -->
                        <DropdownItem name="addType">新增分类</DropdownItem>
                        <DropdownItem name="delType">删除当前分类</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
                <span @click="addFormula">
                    <iconSymbol name="math-addFormula"></iconSymbol>
                </span>
            </div>

            <div class="cal_box" v-show="isBox" ref="calBox" style="max-height: 431px">
                <Tooltip :content="item.hint" placement="bottom-end" v-for="(item, index) in boxList" :key="index" :options="{ modifiers: {} }">
                    <div class="every-box" @click="insertFormulas(index)" @contextmenu.prevent="popMenu($event, index)">
                        <img :src="item.path" alt="" />
                        <div v-if="isMineFormula" class="formulaTool_box">
                            <div @click.stop="delFormula(index)" @mouseenter="removeEnter" @mouseleave="removeLeave">
                                <iconSymbol v-if="!isRemoveHover" name="math-remove" class="deleteBtn"></iconSymbol>
                                <iconSymbol v-if="isRemoveHover" name="math-removeHover" class="deleteBtn"></iconSymbol>
                                <Modal v-model="delModal" width="300px" :mask="false" @on-ok="deleteContent(count)" ok-text="确认" cancel-text="取消">
                                    <p>提示：请确认删除当前公式</p>
                                </Modal>
                            </div>

                            <div @click.stop="updateFormula(index)" @mouseenter="updateEnter" @mouseleave="updateLeave">
                                <iconSymbol v-if="!isUpdateHover" name="math-refresh" class="updateBtn"></iconSymbol>
                                <iconSymbol v-if="isUpdateHover" name="math-refreshHover" class="updateBtn"></iconSymbol>
                                <Modal
                                    v-model="updateModal"
                                    width="300px"
                                    :mask="false"
                                    @on-ok="updateContent(count)"
                                    ok-text="确认"
                                    cancel-text="取消"
                                >
                                    <p>提示：请确认更新当前公式</p>
                                </Modal>
                            </div>
                        </div>
                    </div>
                </Tooltip>
            </div>
        </div>
        <!-- <div id="pop-menu" v-show="isPopMenuShow" v-click-outside='hideMenu' @click='hideMenu'>
            <div class="every-menu" @click="addContent($event)">Add new formula</div>
            <div class="every-menu" @click="updateContent($event)">Update current formula</div>
            <div class="every-menu" @click="deleteContent()">Delete current formula</div>
        </div> -->
        <Modal v-model="modal" width="300px" @on-ok="ok" @on-cancel="cancel" ok-text="确认" cancel-text="取消">
            <p>请输入：</p>
            <br />
            <Input v-model="nameSelf" placeholder="自定义公式名称..." style="width: 200px" />
        </Modal>
        <Modal v-model="typeActionModal" width="300px" @on-ok="typeActionOK" @on-cancel="cancel" ok-text="确认" cancel-text="取消">
            <p v-if="typeActionIndex == 0 || typeActionIndex == 1">请输入：</p>
            <br />
            <Input v-if="typeActionIndex == 0" v-model="renameStr" placeholder="自定义分类名称..." style="width: 200px" />
            <Input v-else-if="typeActionIndex == 1" v-model="newTypeStr" placeholder="新建分类名称..." style="width: 200px" />
            <p v-else>提示：删除分类会删除分类下全部公式</p>
        </Modal>
        <Modal v-model="nMem" width="300px" ok-text="确认" cancel-text="取消">
            <p v-text="alertText"></p>
        </Modal>
    </div>
</template>

<script>
    import formulaData from "../mixins/formulaData";
    import axios from "axios";
    import { directive as clickOutside } from "v-click-outside";
    export default {
        name: "formulaData",
        inject: ["EDMathUI"],
        mixins: [formulaData],
        components: {},
        directives: { clickOutside },
        data() {
            return {
                isBox: false,
                isMineFormula: false, // 当前展示的是否我的公式
                isUpdateHover: false, // 当前展示的加载鼠标是否悬停
                isRemoveHover: false,
                titleName: "",
                parentName: "",
                boxList: [],
                isPopMenuShow: false,
                currentIndex: 0,
                nameSelf: "",
                modal: false,
                delModal: false,
                updateModal: false,
                nMem: false,
                count: 0,
                MathApi: null,
                typeActionModal: false,
                renameStr: "",
                newTypeStr: "",
                typeIndex: 0,
                typeActionIndex: 0,
                typeList: [],
                onlineBoxList: [],
                alertText: "非会员只能创建三个自定义公式",
            };
        },
        watch: {
            // 设置每次下弹框的最大高度
            boxList(val) {
                if (val) {
                    let h = document.body.clientHeight - 320;
                    // this.$refs.calBox.style.maxHeight = h + "px";
                    // this.$refs.calBox.style.maxHeight = window.screen.height * 0.52 + 132 + "px";
                }
            },
            titleName() {
                this.$refs.calBox.scrollTop = 0;
            },
            isBox() {
                this.$refs.calBox.scrollTop = 0;
            },
            userInfo() {
                if (this.userInfo) {
                    this.initType();
                }
            },
        },
        methods: {
            ok() {
                let mml = this.EDMathUI.view.outputMml();
                let png = this.EDMathUI.view.outputPngURL();
                // 获取localStorage里的缓存公式数据
                this.uploadPreview(png, "add", {
                    name: this.nameSelf,
                    content: mml,
                    thumbnail: "",
                    category_id: this.typeList[this.typeIndex].id,
                });
                this.formulaLocal("add", 0, [this.nameSelf, mml, png]);

                if (!this.$store.state.islog) {
                    // 未在线使用本地缓存
                    if (this.isMineFormula) {
                        this.boxList.push({
                            hint: this.nameSelf,
                            path: png,
                        });
                    }
                }
                this.nameSelf = "";
            },
            typeActionOK() {
                switch (this.typeActionIndex) {
                    case 0: {
                        // 重命名
                        if (!this.checkRepeat(this.renameStr)) {
                            alert("不能与现有分类重名");
                            return;
                        }
                        if (this.renameStr.length > 50) {
                            alert("不能超过50个字符");
                            return;
                        }
                        this.typeOnline("update", {
                            id: this.typeList[this.typeIndex].id,
                            newname: this.renameStr,
                        });

                        this.titleName = this.renameStr;
                        this.typeList[this.typeIndex].name = this.renameStr;

                        this.formulaLocal("updateType", 0, this.renameStr); // 修改localStorage对应数据
                        this.typeLocal("update", this.typeIndex, this.typeList[this.typeIndex]); // 修改localStorage对应数据
                        this.renameStr = "";
                        break;
                    }
                    case 1: {
                        // 新增分类
                        if (!this.checkRepeat(this.newTypeStr)) {
                            alert("不能与现有分类重名");
                            return;
                        }
                        this.typeOnline("add", { name: this.newTypeStr });

                        this.newTypeStr = "";
                        break;
                    }
                    case 2: {
                        // 删除分类
                        this.typeOnline("del", this.typeList[this.typeIndex].id);

                        this.typeLocal("del", this.typeIndex); // 删除localStorage对应数据
                        this.formulaLocal("delType"); // 删除localStorage对应数据
                        this.typeList.splice(this.typeIndex, 1);
                        this.isBox = false;
                        break;
                    }
                }
            },
            cancel() {
                this.nameSelf = "";
                this.renameStr = "";
            },

            getCatalog(name) {
                // 弹出内容
                // 选择基础公式
                this.boxList = [];
                this.isMineFormula = false;

                if (name) {
                    this.titleName = name;
                    this.isBox = true;
                    let currentIndex = 0;
                    for (let i = 0; i < this.pngList.length; i++) {
                        if (name == this.pngList[i].type) {
                            currentIndex = i;
                            break;
                        }
                    }

                    if (this.pris.includes(this.pngList[currentIndex].type)) {
                        this.parentName = "小学";
                    } else if (this.mids.includes(this.pngList[currentIndex].type)) {
                        this.parentName = "初中";
                    } else if (this.higs.includes(this.pngList[currentIndex].type)) {
                        this.parentName = "高中";
                    } else if (this.unis.includes(this.pngList[currentIndex].type)) {
                        this.parentName = "大学";
                    }

                    for (let i in this.pngList[currentIndex].list) {
                        this.boxList.push({
                            hint: i,
                            path: this.pngList[currentIndex].list[i],
                        });
                    }
                }
            },
            getMineFormula(name) {
                // 选择分类
                this.boxList = [];
                this.isMineFormula = true;
                if (name) {
                    let typeID = 0;
                    this.titleName = name;
                    this.isBox = true;
                    for (let i = 0; i < this.typeList.length; i++) {
                        if (name == this.typeList[i].name) {
                            this.typeIndex = i;
                            typeID = this.typeList[i].id;
                            break;
                        }
                    }
                    if (this.$store.state.islog) {
                        // 在线状态，获取在线数据
                        for (let i = 0; i < this.onlineBoxList.length; i++) {
                            if (typeID == this.onlineBoxList[i].category_id) {
                                let time = new Date().getTime();
                                let path = this.onlineBoxList[i].thumbnail.replace(/\?.*/, "") + "?" + time;
                                this.boxList.push({
                                    id: this.onlineBoxList[i].id,
                                    hint: this.onlineBoxList[i].name,
                                    path: window["GLOBAL"].PUBLIC_OSS_HOST + path,
                                    content: this.onlineBoxList[i].content,
                                });
                            }
                        }
                    } else {
                        let storageData = this.formulaLocal("get");
                        if (storageData) {
                            for (let i = 0; i < storageData.length; i++) {
                                if (storageData[i].type == this.typeList[this.typeIndex].name) {
                                    for (let j = 0; j < storageData[i].data.length; j++) {
                                        if (storageData[i].data) {
                                            this.boxList.push({
                                                hint: storageData[i].data[j][0],
                                                path: storageData[i].data[j][2],
                                            });
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            },
            addFormula() {
                this.modal = true;
            },
            updateFormula(count) {
                this.count = count;
                this.updateModal = true;
            },
            delFormula(count) {
                this.count = count;
                this.delModal = true;
            },
            updateEnter() {
                this.isUpdateHover = true;
            },
            removeEnter() {
                this.isRemoveHover = true;
            },
            updateLeave() {
                this.isUpdateHover = false;
            },
            removeLeave() {
                this.isRemoveHover = false;
            },
            open() {
                if (this.typeList.length == 0) {
                    this.$bus.$emit("openBox");
                }
            },
            selectTypeAction(name) {
                // 选择分类操作动作
                switch (name) {
                    case "rename": {
                        if (this.typeList[this.typeIndex].name == "默认") {
                            alert("默认分类不可修改名称！");
                            return;
                        }
                        this.typeActionModal = true;
                        this.typeActionIndex = 0;
                        break;
                    }
                    case "addType": {
                        this.typeActionModal = true;
                        this.typeActionIndex = 1;
                        break;
                    }
                    case "delType": {
                        if (this.typeList[this.typeIndex].name == "默认") {
                            alert("默认分类不可删除！");
                            return;
                        }
                        this.typeActionModal = true;
                        this.typeActionIndex = 2;
                        break;
                    }
                }
            },

            closeBox() {
                // 关闭下拉内容
                this.isBox = false;
                this.boxList = [];
            },

            insertFormulas(index) {
                // 插入公式
                if (!this.isMineFormula) {
                    let sum = 0;
                    for (let i = 0; i < this.pngList.length; i++) {
                        if (this.pngList[i].type == this.titleName) break;
                        sum++;
                    }
                    axios
                        .get(this.mmlList[sum][index], {
                            responseType: "blob",
                        })
                        .then((res) => {
                            var reader = new FileReader();
                            reader.readAsText(res.data, "gbk"); //发起异步请求
                            reader.addEventListener("load", (e) => {
                                try {
                                    if (e.target.result) {
                                        this.EDMathUI.view.insertStdMml(e.target.result);
                                    }
                                } catch (err) {
                                    this.$edMessage.error("公式读取失败");
                                }
                            });
                        })
                        .catch((error) => {
                            this.$edMessage.error("公式读取失败");
                        });
                } else {
                    if (this.$store.state.islog) {
                        // 在线状态
                        this.EDMathUI.view.insertStdMml(this.boxList[index].content);
                    } else {
                        let getStorage = this.formulaLocal("get");
                        let target;
                        for (let i = 0; i < getStorage.length; i++) {
                            if (getStorage[i].type == this.typeList[this.typeIndex].name) {
                                target = getStorage[i].data;
                            }
                        }
                        this.EDMathUI.view.insertStdMml(target[index][1]);
                    }
                }
            },

            popMenu(event, index) {
                // 弹出右键菜单
                if (this.titleName === "自定义公式") {
                    event.preventDefault();
                    var pop = document.getElementById("pop-menu");

                    pop.style.top = event.clientY - 100 + "px";
                    pop.style.left = event.layerX + 4 + "px";
                    if (!this.isPopMenuShow) this.isPopMenuShow = true;
                    this.currentIndex = index;
                }
            },

            hideMenu() {
                // 隐藏菜单
                this.isPopMenuShow = false;
            },

            addContent() {
                // 新增公式
                this.modal = true;
            },

            deleteContent(index) {
                // 删除自定义公式同时删除对应的缓存
                this.isPopMenuShow = false;

                this.formulaOnline("del", 0, this.boxList[index].id);
                // this.formulaLocal('del', index);
                if (this.$store.state.islog) {
                    for (let i = 0; i < this.onlineBoxList.length; i++) {
                        if (this.onlineBoxList[i].id == this.boxList[index].id) {
                            this.onlineBoxList.splice(i, 1);
                            break;
                        }
                    }
                }
                this.boxList.splice(index, 1);
            },

            updateContent(index) {
                // 更新自定义公式同时更新对应的缓存
                if (this.$store.state.islog) {
                    //更新view //更新在线数据
                    this.uploadPreview(
                        this.EDMathUI.view.outputPngURL(),
                        "update",
                        {
                            name: this.nameSelf,
                            content: this.EDMathUI.view.outputMml(),
                            category_id: this.typeList[this.typeIndex].id,
                        },
                        this.boxList[index].id
                    );
                    let temp = JSON.parse(JSON.stringify(this.boxList[index]));
                    temp.path = this.EDMathUI.view.outputPngURL();
                    temp.content = this.EDMathUI.view.outputMml();
                    this.boxList.splice(index, 1, temp);
                } else {
                    //更新view 更新本地缓存
                    let getName = this.formulaLocal("update", index, {
                        mml: this.EDMathUI.view.outputMml(),
                        png: this.EDMathUI.view.outputPngURL(),
                    });
                    this.boxList.splice(index, 1, {
                        hint: getName,
                        path: this.EDMathUI.view.outputPngURL(),
                    });
                }
            },

            checkRepeat(str) {
                // 检查分类是否重名
                for (let i = 0; i < this.typeList.length; i++) {
                    if (str == this.typeList[i].name) {
                        return false;
                    }
                }
                return true;
            },

            dataURLtoBlob(dataurl) {
                var arr = dataurl.split(","),
                    mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]),
                    n = bstr.length,
                    u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new Blob([u8arr], { type: mime });
            },
            blobToFile(theBlob, fileName) {
                theBlob.lastModifiedDate = new Date();
                theBlob.name = fileName;
                return theBlob;
            },
            toFile(str) {
                let blob = this.dataURLtoBlob(str);
                return this.blobToFile(blob, "preview");
            },

            uploadPreview(src, str, formula, formulaID) {
                // 上传图片到阿里云，保存公式到服务器
                let ts = this;
                let getURL;
                getURL =
                    str == "update"
                        ? `/api/user/${this.userInfo.user_id}/math/${formulaID}/thumbnail?token=${this.$store.state.token}&id=${this.userInfo.user_id}&math_id=${formulaID}`
                        : `/api/user/${this.userInfo.user_id}/math/thumbnail?token=${this.$store.state.token}&id=${this.userInfo.user_id}`;
                let host,
                    policyBase64,
                    accessid,
                    signature,
                    expire = 0,
                    url,
                    path;
                this.MathApi.get(getURL)
                    .then((response) => {
                        var now = Date.parse(new Date()) / 1000;
                        if (expire < now + 3) {
                            let obj = response.data.data;
                            host = obj["host"];
                            policyBase64 = obj["policy"];
                            accessid = obj["id"];
                            signature = obj["sign"];
                            expire = parseInt(obj["exp"]);
                            str == "update" ? (url = obj["path"] + obj["uri"]) : (url = obj["path"] + obj["uri"] + "preview.png");
                            path = obj["path"];
                        }
                        let imgfile = this.toFile(src);

                        let file = new FormData();
                        file.append("key", url);
                        file.append("policy", policyBase64);
                        file.append("OSSAccessKeyId", accessid);
                        file.append("success_action_status", 200);
                        file.append("signature", signature);
                        file.append("file", imgfile);
                        axios
                            .post(host, file)
                            .then((response) => {
                                formula.thumbnail = url;
                                ts.formulaOnline(str, formula, formulaID, url);
                            })
                            .catch((error) => {
                                console.log("保存公式失败", error);
                            });
                    })
                    .catch(function (error) {
                        console.log("oss 上传图片失败", error);
                    });
            },
            typeLocal(str, index, data) {
                let oldStorage = localStorage.getItem("EdrawSoftMathType");
                let jsonSelf = JSON.parse(oldStorage);
                switch (str) {
                    case "add": {
                        if (oldStorage) {
                            // 缓存原本存在
                            jsonSelf.push(data);
                            jsonSelf = JSON.stringify(jsonSelf);
                        } else {
                            // 缓存原本不存在
                            let arr = [
                                {
                                    id: 0,
                                    name: "默认",
                                    created_at: "2019-03-06 00:00:00",
                                },
                            ];
                            arr.push(data);
                            jsonSelf = JSON.stringify(arr);

                            let Formula = localStorage.getItem("EdrawSoftMathFormula"); // 新增分类的时候初始化本地公式第一条数据
                            if (!Formula) {
                                let arr = [{ type: "默认", data: [] }];
                                Formula = JSON.stringify(arr);
                                localStorage.setItem("EdrawSoftMathFormula", Formula);
                            }
                        }
                        break;
                    }
                    case "del": {
                        if (oldStorage) {
                            jsonSelf.splice(index, 1);
                            jsonSelf = JSON.stringify(jsonSelf);
                        }
                        break;
                    }
                    case "get": {
                        return jsonSelf;
                        break;
                    }
                    case "update": {
                        if (oldStorage) {
                            jsonSelf.splice(index, 1, data);
                            jsonSelf = JSON.stringify(jsonSelf);
                        }
                        break;
                    }
                }

                localStorage.setItem("EdrawSoftMathType", jsonSelf);
            },
            formulaLocal(str, index, data) {
                let oldStorage = localStorage.getItem("EdrawSoftMathFormula");
                let jsonSelf = JSON.parse(oldStorage);
                switch (str) {
                    case "add": {
                        let newSelf = data;
                        if (oldStorage) {
                            // 缓存原本存在
                            let dataExit = false;
                            for (let i = 0; i < jsonSelf.length; i++) {
                                // 一次循环判断分类是否存在
                                if (jsonSelf[i].type == this.typeList[this.typeIndex].name) {
                                    jsonSelf[i].data.push(newSelf);
                                    dataExit = true;
                                    break;
                                }
                            }
                            if (!dataExit) {
                                // 分类不存在新增分类
                                let obj = {
                                    type: this.typeList[this.typeIndex].name,
                                    data: [newSelf],
                                };
                                jsonSelf.push(obj);
                            }
                            jsonSelf = JSON.stringify(jsonSelf);
                        } else {
                            // 缓存原本不存在
                            let obj = {
                                type: this.typeList[this.typeIndex].name,
                                data: [newSelf],
                            };
                            let arr = [{ type: "默认", data: [] }];
                            arr.push(obj);
                            jsonSelf = JSON.stringify(arr);
                        }
                        break;
                    }
                    case "del": {
                        if (oldStorage) {
                            for (let i = 0; i < jsonSelf.length; i++) {
                                if (jsonSelf[i].type == this.typeList[this.typeIndex].name) {
                                    jsonSelf[i].data.splice(index, 1);
                                }
                            }
                            jsonSelf = JSON.stringify(jsonSelf);
                        }
                        break;
                    }
                    case "get": {
                        return jsonSelf;
                        break;
                    }
                    case "update": {
                        let name;
                        if (oldStorage) {
                            for (let i = 0; i < jsonSelf.length; i++) {
                                if (jsonSelf[i].type == this.typeList[this.typeIndex].name) {
                                    name = jsonSelf[i].data[index][0];
                                    jsonSelf[i].data.splice(index, 1, [name, data.mml, data.png]);
                                }
                            }
                            jsonSelf = JSON.stringify(jsonSelf);
                            localStorage.setItem("EdrawSoftMathFormula", jsonSelf);
                        }
                        return name;
                    }
                    case "updateType": {
                        // 更新分类名称
                        if (oldStorage) {
                            for (let i = 0; i < jsonSelf.length; i++) {
                                if (jsonSelf[i].type == this.typeList[this.typeIndex].name) {
                                    jsonSelf[i].type = data;
                                    break;
                                }
                            }
                            jsonSelf = JSON.stringify(jsonSelf);
                        }
                        break;
                    }
                    case "delType": {
                        // 删除分类
                        if (jsonSelf && jsonSelf.length != 1) {
                            for (let i = 0; i < jsonSelf.length; i++) {
                                if (jsonSelf[i].type == this.typeList[this.typeIndex].name) {
                                    jsonSelf.splice(i, 1);
                                    break;
                                }
                            }
                            jsonSelf = JSON.stringify(jsonSelf);
                        }
                        break;
                    }
                }

                localStorage.setItem("EdrawSoftMathFormula", jsonSelf);
            },
            initType() {
                // 获取分类列表，获取公式数据
                this.typeOnline("get");
                this.formulaOnline("get");
            },
            typeOnline(str, typedata) {
                // 分类相关的网络操作
                let ts = this;
                switch (str) {
                    case "add": {
                        this.MathApi.post(`/api/user/${this.userInfo.user_id}/math/category`, typedata, {
                            headers: {
                                Authorization: "Bearer " + this.$store.state.token,
                            },
                        })
                            .then((response) => {
                                console.log(response);
                                ts.typeList.push(response.data.data);
                                ts.typeLocal("add", 0, response.data.data); // 添加到localStorage
                                ts.getMineFormula(typedata.name); // 进入新创建的分类
                            })
                            .catch(function (error) {
                                ts.alertText = "增加分类失败";
                                ts.nMem = true;
                            });
                        break;
                    }
                    case "del": {
                        this.MathApi.delete(`/api/user/${this.userInfo.user_id}/math/category/${typedata}`, {
                            headers: {
                                Authorization: "Bearer " + this.$store.state.token,
                            },
                        })
                            .then((response) => {
                                console.log(response);
                            })
                            .catch(function (error) {
                                ts.alertText = "删除分类失败";
                                ts.nMem = true;
                            });
                        break;
                    }
                    case "update": {
                        this.MathApi.put(
                            `/api/user/${this.userInfo.user_id}/math/category/${typedata.id}`,
                            { name: typedata.newname },
                            {
                                headers: {
                                    Authorization: "Bearer " + this.$store.state.token,
                                },
                            }
                        )
                            .then((response) => {
                                ts.getMineFormula(typedata.newname);
                            })
                            .catch(function (error) {
                                ts.alertText = "更新分类失败";
                                ts.nMem = true;
                            });
                        break;
                    }
                    case "get": {
                        this.MathApi.get(`/api/user/${this.userInfo.user_id}/math/category?token=${this.$store.state.token}&offset=0&count=10000`)
                            .then((response) => {
                                let arr = [
                                    {
                                        id: 0,
                                        name: "默认",
                                        created_at: "2019-03-06 00:00:00",
                                    },
                                ];
                                ts.typeList = arr.concat(response.data.data);
                            })
                            .catch(function (error) {
                                ts.alertText = "获取分类失败";
                                ts.nMem = true;
                            });
                        break;
                    }
                }
            },
            formulaOnline(str, formula, formulaID, formulaURL) {
                // 公式相关的网络操作
                let ts = this;
                // alert(this.nMen);
                switch (str) {
                    case "add": {
                        this.MathApi.post(`/api/user/${this.userInfo.user_id}/math`, formula, {
                            headers: {
                                Authorization: "Bearer " + this.$store.state.token,
                            },
                        })
                            .then((response) => {
                                ts.boxList.push({
                                    id: response.data.data.id,
                                    hint: formula.name,
                                    path: window["GLOBAL"].PUBLIC_OSS_HOST + formulaURL,
                                    category_id: formula.category_id,
                                    content: formula.content,
                                });
                                ts.onlineBoxList.push({
                                    id: response.data.data.id,
                                    name: formula.name,
                                    thumbnail: formulaURL,
                                    category_id: formula.category_id,
                                    content: formula.content,
                                });
                            })
                            .catch(function (error) {
                                if (error.response.status == 403) {
                                    ts.alertText = "非会员只能创建三个自定义公式";
                                } else {
                                    ts.alertText = "增加公式失败";
                                }
                                ts.nMem = true;
                            });
                        break;
                    }
                    case "del": {
                        this.MathApi.delete(`/api/user/${this.userInfo.user_id}/math/${formulaID}`, {
                            headers: {
                                Authorization: "Bearer " + this.$store.state.token,
                            },
                        })
                            .then((response) => {
                                console.log(response);
                            })
                            .catch(function (error) {
                                ts.alertText = "删除公式失败";
                                ts.nMem = true;
                            });
                        break;
                    }
                    case "get": {
                        this.MathApi.get(`/api/user/${this.userInfo.user_id}/math?token=${this.$store.state.token}&offset=0&count=10000`)
                            .then((response) => {
                                ts.onlineBoxList = response.data.data;
                            })
                            .catch(function (error) {
                                ts.alertText = "获取公式失败";
                                ts.nMem = true;
                            });
                        break;
                    }
                    case "update": {
                        this.MathApi.put(`/api/user/${this.userInfo.user_id}/math/${formulaID}`, formula, {
                            headers: {
                                Authorization: "Bearer " + this.$store.state.token,
                            },
                        })
                            .then((response) => {
                                let data = response.data.data;
                                for (let j = 0; j < this.onlineBoxList.length; j++) {
                                    if (this.onlineBoxList[j].id == data.id) {
                                        this.onlineBoxList[j] = data;
                                    }
                                }
                            })
                            .catch(function (error) {
                                ts.alertText = "更新公式失败";
                                ts.nMem = true;
                            });
                        break;
                    }
                }
            },
        },
        mounted() {
            this.$bus.$on("scrollSet", (sum, i) => {
                this.boxList = [];
                for (let val in this.pngList[i].list) {
                    this.boxList.push({
                        hint: val,
                        path: this.pngList[i].list[val],
                    });
                }
                this.isBox = true;
                this.titleName = this.pngList[i].type;
                this.$nextTick(() => {
                    this.$refs.calBox.scrollTop = 116 * sum;
                });
            });
            this.$bus.$on("updateBoxList", (arr) => {
                if (this.titleName === "自定义公式") {
                    if (!arr[3]) {
                        this.boxList.push({
                            hint: arr[0],
                            path: arr[2],
                        });
                    } else {
                        this.getCatalog("自定义公式");
                    }
                }
            });
            this.$bus.$on("clearBoxList", () => {
                this.boxList.splice(0, this.boxList.length);
                this.typeList.splice(0, this.typeList.length);
                this.isBox = false;
            });
        },
        computed: {
            nolimit() {
                return this.$store.state.ui.nolimitMath;
            },
            userInfo() {
                return this.$store.state.userdata;
            },
            pris() {
                let pris = ["单位换算", "分数", "几何图形计算", "数量关系计算", "算术定律", "应用题公式"];
                return pris;
            },
            mids() {
                let mids = ["乘法与因式分解", "基础代数", "几何图形", "解析几何", "三角不等式", "三角函数", "基础数列", "一元二次方程"];
                return mids;
            },
            higs() {
                let higs = ["不等式", "初等函数", "导数", "方程", "基础知识", "数列", "图形几何", "向量"];
                return higs;
            },
            unis() {
                let unis = ["常微分方程", "有理函数", "代数", "微积分", "无穷级数", "概率论", "线性代数"];
                return unis;
            },
            sels() {
                let sels = ["自定义公式"];
                return sels;
            },
        },
        beforeDestroy() {
            this.$bus.$off("scrollSet");
            this.$bus.$off("updateBoxList");
            this.$bus.$off("clearBoxList");
        },
        created() {
            this.MathApi = axios.create({
                baseURL: this.urls.apiUrl,
                timeout: 5000,
            });
        },
    };
</script>
